import { storageKeys } from '../../../../utils/browser-storage/storage-keys';
import isUITest from '../../../../utils/is-ui-test';
import session from '../../../../utils/session';

export default function () {
    // const whiteListedIDs = [];
    // const id = window.storage.getItem(storageKeys.user.userId);
    // const evenUserId = Number(id) > 0 && (Number(id) % 2 === 0);
    const impersonated = Number(window.storage.getItem(storageKeys.user.impersonated)) === 1;
    const permissions = {
        showPopup: false
    };

    if (session.isLoggedIn() && !impersonated && !isUITest()) {
        permissions.showPopup = true;
    }

    return permissions;
}
